export default "__VITE_ASSET__fGBAeS0g__"